import { Builder } from '@builder.io/react';

import SlideGallery from './index';

Builder.registerComponent(SlideGallery, {
  name: 'SlideGallery',
  inputs: [
    {
      name: 'featureList',
      type: 'list',
      defaultValue: [
        {
          title: 'Title',
          description: 'Description'
        }
      ],
      subFields: [
        {
          name: 'title',
          type: 'string',
          required: true
        },
        {
          name: 'description',
          type: 'string',
          required: true
        },
        {
          name: 'image',
          type: 'object',
          subFields: [
            {
              name: 'src',
              type: 'file',
              allowedFileTypes: ['jpeg', 'jpg', 'png', 'svg']
            },
            {
              name: 'alt',
              type: 'string'
            },
            { name: 'width', type: 'number' },
            { name: 'height', type: 'number' }
          ]
        },
        {
          name: 'icon',
          type: 'object',
          subFields: [
            {
              name: 'src',
              type: 'file',
              allowedFileTypes: ['jpeg', 'jpg', 'png', 'svg']
            },
            {
              name: 'alt',
              type: 'string'
            }
          ]
        }
      ]
    }
  ]
});
